/* eslint-disable no-mixed-spaces-and-tabs,no-tabs,@typescript-eslint/no-unused-vars */

xplenty.directive('alertBox', [
  '$location',

  function ($location) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('../../../views/directives/alert-box.html'),

      replace: true,

      scope: {
        data: '=ngModel',
      },

      link(scope, element, attrs) {
        const $icon = element.find('.alert-box-icon use');
        const absUrl = $location.absUrl();

        $icon.attr('href', absUrl + scope.data.icon);
      },
    };
  },
]);
